module.exports = __webpack_public_path__ + "img/thumb_02.668ba628.jpg";